import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useContext, useRef, useState } from 'react';
import cls from 'clsx';
import { pick } from '../utils';
import Icon from '../icon';
import Swiper from '../swiper';
import Popup from '../popup';
import ImagePreviewItem from './ImagePreviewItem';
import ConfigProviderContext from '../config-provider/ConfigProviderContext';

var ImagePreview = function ImagePreview(props) {
  var _useContext = useContext(ConfigProviderContext),
      prefixCls = _useContext.prefixCls,
      createNamespace = _useContext.createNamespace;

  var _createNamespace = createNamespace('image-preview', prefixCls),
      _createNamespace2 = _slicedToArray(_createNamespace, 1),
      bem = _createNamespace2[0];

  var swiperRef = useRef(null);

  var _useState = useState(function () {
    return props.startPosition;
  }),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var onSwipeChange = function onSwipeChange(idx) {
    if (active !== idx) {
      var _props$onChange;

      setActive(idx);
      (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, idx);
    }
  };

  var renderImages = function renderImages() {
    return /*#__PURE__*/React.createElement(Swiper, {
      ref: swiperRef,
      className: cls(bem('swipe')),
      loop: props.loop,
      duration: props.swipeDuration,
      initialSwipe: active,
      onChange: onSwipeChange,
      indicator: props.showIndicators
    }, props.images.map(function (image, i) {
      return /*#__PURE__*/React.createElement(Swiper.Item, {
        className: cls(bem('item')),
        key: image
      }, /*#__PURE__*/React.createElement(ImagePreviewItem, {
        maxZoom: props.maxZoom,
        image: image,
        lazyload: props.lazyload,
        onTap: function onTap() {
          var _props$onClose;

          (_props$onClose = props.onClose) === null || _props$onClose === void 0 ? void 0 : _props$onClose.call(props, {
            url: image,
            index: i
          });
        },
        onZoomChange: function onZoomChange(zoom) {
          if (zoom !== 1) {
            var _swiperRef$current;

            (_swiperRef$current = swiperRef.current) === null || _swiperRef$current === void 0 ? void 0 : _swiperRef$current.lock();
          } else {
            var _swiperRef$current2;

            (_swiperRef$current2 = swiperRef.current) === null || _swiperRef$current2 === void 0 ? void 0 : _swiperRef$current2.unlock();
          }
        }
      }));
    }));
  };

  var renderClose = function renderClose() {
    if (props.closeable) {
      return /*#__PURE__*/React.createElement(Icon, {
        name: props.closeIcon,
        className: cls(bem('close-icon', props.closeIconPosition)),
        onClick: function onClick() {
          var _props$onClose2;

          return (_props$onClose2 = props.onClose) === null || _props$onClose2 === void 0 ? void 0 : _props$onClose2.call(props);
        }
      });
    }

    return null;
  };

  var renderIndex = function renderIndex() {
    if (props.showIndex) {
      return /*#__PURE__*/React.createElement("div", {
        className: cls(bem('index'))
      }, props.indexRender ? props.indexRender({
        index: active,
        len: props.images.length
      }) : "".concat(active + 1, " / ").concat(props.images.length));
    }

    return null;
  };

  return /*#__PURE__*/React.createElement(Popup, _extends({
    className: cls(bem(), props.className),
    overlayClass: cls(bem('overlay')),
    beforeClose: props.beforeClose
  }, pick(props, ['visible', 'overlayStyle', 'closeOnPopstate', 'onClose', 'onClosed'])), renderClose(), renderImages(), renderIndex());
};

ImagePreview.defaultProps = {
  loop: true,
  overlay: true,
  showIndex: true,
  images: [],
  swipeDuration: 300,
  startPosition: 0,
  closeIcon: 'clear',
  closeIconPosition: 'top-right',
  showIndicators: false,
  maxZoom: 3
};
export default ImagePreview;